<div class="border-b border-ui-separator">
  <lla-table-filter
    [advancedFilterKey]="advancedFilterKey"
    [filter]="filter"
    (filterChanged)="filterChanged.emit($event)"
    [forOverview]="true"
  ></lla-table-filter>

  <lla-table-filters-list
    [advancedFilterKey]="advancedFilterKey"
    [overviewKey]="overviewKey"
    (clearAllFilters)="clearAllFilters.emit()"
    [tableActions]="tableActions"
    (filterChanged)="filterChanged.emit($event)"
  ></lla-table-filters-list>
</div>
